<ejs-dialog #modal [isModal]='true' 
    [header]="'Períodicidade de Exame por Paciente'" 
    [target]="'body'"
    [visible]="false"
    width="700px"
    [ngClass]="{ 'em-operacao': emOperacao }"
    height="590px"
    class="custom-dialog"
    [showCloseIcon]='true' [id]="id"
    (beforeClose)="fechandoModal($event)"
    (beforeOpen)="tabOk=true"
    [closeOnEscape]='true'>

    <ng-template #content>
        <ejs-tab  #tab class='e-fill' *ngIf="tabOk">
            <div class="e-tab-header">
                <div>Informações Gerais</div>
            </div>
            <div class="e-content">
                <div class="" style="padding: 15px">
                    <form [formGroup]='modelo' [ngClass]="{'submitted': submetido}">
                        <div class='row' style="width: 100%">
                            <div class='col-xs-12 form-group' required>
                                <ax-edit-button [placeholder]="'Exame Natureza'"
                                [enabled]="alteracaoExameLiberada && !apenasConsulta"
                                [formControlName]="'exameNaturezaTexto'" 
                                (onClick)="exameNatureza.abrirTelaCheia()"
                                [label]="'Exame Natureza'"></ax-edit-button>
                                <app-error-handler [control]="modelo.get('exameNaturezaTexto')" [submitted]='submetido'
                                [errorType]="'required'">
                                </app-error-handler>
                            </div>
                            <div class='col-xs-12 form-group' required>
                                <ax-select [label]="'Periodicidade'" formControlName="periodicidadeId" 
                                [appendTo]="'#'+id"
                                [enabled]="!apenasConsulta"
                                [dataSource]="dsPeriodicidades">
                                </ax-select>  
                                <app-error-handler [control]="modelo.get('periodicidadeId')" [submitted]='submetido'
                                [errorType]="'required'">
                                </app-error-handler>
                            </div>
                            <div class='col-xs-12 form-group'>
                                <ejs-textbox [placeholder]="'Motivo'" 
                                [floatLabelType]="'Always'"
                                rows="5"
                                [enabled]="!apenasConsulta"
                                [multiline]="true"
                                formControlName="motivo">
                                </ejs-textbox>  
                            </div>
                            <div class='col-xs-12 form-group' required>
                                <ejs-checkbox [label]="'Ativo'" [disabled]="apenasConsulta" formControlName="ativo">
                                </ejs-checkbox>  
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </ejs-tab>
    
    
    </ng-template>
    
    <ng-template #footerTemplate>
        <button  ejs-button  class=" e-btn e-primary" data-ripple="true" appDebounceClick
        [iconCss]="'fas fa-save'" [disabled]="apenasConsulta"
        (click)='salvar()'>Salvar</button>
        <button ejs-button  class="e-btn " data-ripple="true" (click)='modal.hide()'>Cancelar</button>
    </ng-template>

</ejs-dialog>



<app-exame-natureza-pesquisa [tudo]="true" #exameNatureza (registroSelecionado)="exameNaturezaSelecionado($event)"></app-exame-natureza-pesquisa>


